package com.milta.core.localization.translations.nl

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Nieuwe levering",
    manualDeliverySubtitle = "Voeg een levering toe aan de route",
    recipientNameLabel = "Naam ontvanger",
    addressLabel = "Adres",
    phoneNumberLabel = "Telefoon",
    deliveryTimeLimitLabel = "Uiterste tijd",
    optionalSuffix = "(optioneel)",
    submitButton = "Toevoegen en doorgaan",
    saveEditedDeliveryButton = "Wijziging opslaan",
    deliveryCreated = "Levering toegevoegd",
    errorRecipientNameRequired = "Naam ontvanger is verplicht",
    errorRecipientNameTooLong = "Naam is te lang (max. 150 tekens)",
    errorAddressRequired = "Adres is verplicht",
    errorAddressTooLong = "Adres is te lang (max. 255 tekens)",
    errorPhoneTooLong = "Telefoon is te lang (max. 20 tekens)",
    errorDuplicateDelivery = "Deze levering staat al in de lijst (zelfde ontvanger en adres)",
    errorRouteNotFound = "Route niet gevonden",
    errorForbidden = "U mag deze route niet bewerken",
    errorValidation = "Controleer de ingevoerde velden",
    errorGeneric = "Er is iets misgegaan. Probeer opnieuw.",
    errorRouteNotInProgress = "Deze route is niet meer bezig. Kan geen levering toevoegen.",
    unknownRecipientLabel = "Onbekend",
    driverHomeTitle = "Mijn route",
    driverModeBadge = "Chauffeursmodus",
    routeStatusScheduled = "Gepland",
    routeStatusInProgress = "Bezig",
    routeStatusCompleted = "Voltooid",
    routeStatusPartial = "Gedeeltelijk",
    driversDepartedOne = "vertrokken",
    driversDepartedMany = "vertrokken",
    driversFinishedOne = "klaar",
    driversFinishedMany = "klaar",
    stopsDeliveredLabel = "Geleverd",
    stopsInProgressLabel = "Bezig",
    stopsTodoLabel = "Te doen",
    stopsFailedLabel = "Mislukt",
    stopsUntreatedLabel = "Onbehandeld",
    stopsCountLabel = "stops",
    startRouteButton = "Route starten",
    noRouteTitle = "Geen route",
    noRouteSubtitle = "Er is momenteel geen route aan u toegewezen.",
    noRoutePastSubtitle = "Er is voor deze datum geen route aan u toegewezen.",
    routeInProgressTitle = "Route bezig",
    routeCompletedTitle = "Rit voltooid",
    addStopButton = "Een stop toevoegen",
    errorConflict = "De route is al gestart of voltooid.",
    greetingPrefix = "Hallo",
    routeOfTheDayLabel = "RIT VAN VANDAAG",
    noOtherRouteLabel = "Geen andere rit gepland",
    routeLabel = "Rit",
    importMenuTitle = "Leveringen importeren",
    importMenuSubtitle = "Meerdere combineerbare methodes — kies een bron",
    importModeScanDocumentTitle = "Document scannen",
    importModeScanDocumentDesc = "Fotografeer een lijst of een pakketlabel",
    importModePdfTitle = "PDF importeren",
    importModePdfDesc = "Leveringsbonnen, gescand bestand",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Uw eigen formaat — kolommen automatisch gedetecteerd",
    importModeManualTitle = "Handmatige invoer",
    importModeManualDesc = "Naam, adres, telefoon, uiterste tijd",
    photoSourceSheetTitle = "Hoe wil je de foto toevoegen?",
    photoSourceTakePhoto = "Foto maken",
    photoSourceChooseGallery = "Kiezen uit galerij",
    photoSourceChooseFiles = "Afbeelding kiezen uit bestanden",
    createRouteTitle = "Rit aanmaken",
    routeCardDetailLabel = "Detail",
    importReviewTitle = "Geïmporteerde leveringen controleren",
    importReviewMissingGpsWarning = "GPS-coördinaten ontbreken",
    importReviewRetryGeocodeAction = "Geocodering opnieuw proberen",
    createRouteEmptyDrivers = "Nog geen chauffeurs in uw team",
    editDeliveriesAction = "Bewerken",
    moreDeliveriesLabel = "meer",
    addDeliveriesAction = "Leveringen toevoegen",
    manualEntryAddedConfirmPrefix = "Levering toegevoegd:",
    manualEntryMergedConfirmPrefix = "Pakket toegevoegd aan bestaande levering",
    manualEntryAddedCountLabel = "Toegevoegde leveringen",
    manualEntryFinishButton = "Afronden",
    optimizeRouteButton = "Route optimaliseren",
    createRouteButtonNoOptimize = "Route aanmaken",
    errorNoEnterprise = "Geen onderneming gekoppeld aan uw account",
    errorDriverNotFound = "Chauffeur niet gevonden",
    errorNoDeliveries = "Voeg minstens één levering toe voordat u de route optimaliseert",
    errorOptimizationUnavailable = "De optimalisatieservice is tijdelijk niet beschikbaar.",
    errorGeocodingFailed = "Sommige bezorgadressen konden niet worden gevonden. Pas het adres aan en probeer opnieuw.",
    dispatchTitle = "Optimalisatie",
    optimizedSuccessTitle = "Route geoptimaliseerd!",
    optimizedSuccessSubtitleSuffix = "stops in de kortste volgorde",
    stopsStatLabel = "Stops",
    stopDetailTitlePrefix = "Stop",
    stopStatusCurrentLabel = "Bezig",
    stopStatusUpcomingLabel = "Binnenkort",
    stopStatusDeliveredLabel = "Geleverd",
    stopStatusFailedLabel = "Mislukt",
    stopRecipientLabel = "Ontvanger",
    callActionLabel = "Bellen",
    noPhoneLabel = "Geen telefoon opgegeven",
    packagesCountLabel = "pakketten",
    navigateButton = "Navigeren",
    navigationUnavailableUnverifiedAddress = "Adres niet geverifieerd: navigatie niet beschikbaar voor deze stop.",
    deadlineBeforePrefix = "Vóór",
    deadlinePastSuffix = "verlopen",
    validateStopAction = "Deze stop valideren",
    teamDashboardTitle = "Ritten",
    todayDateLabel = "Vandaag",
    statRoutesLabel = "Ritten",
    statDeliveriesLabel = "Leveringen",
    statCompletedLabel = "Voltooid",
    teamSectionTitle = "Team",
    routeStartedAtPrefix = "Gestart om",
    routeCompletedAtPrefix = "Voltooid om",
    routeNotStartedLabel = "Niet gestart",
    emptyTeamRoutesTitle = "Geen rit op die dag",
    emptyTeamRoutesSubtitle = "Geen enkele chauffeur van het team heeft een rit gepland voor deze datum.",
    errorInvalidDate = "Ongeldige datum",
    routeDetailTitle = "Ritdetails",
    driverEyebrowLabel = "Chauffeur",
    failedDeliveryTag = "Levering mislukt",
    driverLoadingCheckTitle = "Laadcontrole",
    loadingCheckInstructionText = "Controleer of alle verwachte pakketten in het voertuig zijn geladen voordat u vertrekt.",
    expectedPackagesLabel = "pakketten verwacht voor deze route",
    confirmLoadCheckboxPrefix = "Ik heb de",
    confirmLoadCheckboxSuffix = "verwachte pakketten voor deze route geladen",
    reportDiscrepancyToggleLabel = "Een afwijking melden",
    discrepancyNotePlaceholder = "Bijv.: ik heb 9 pakketten geladen in plaats van 11…",
    discrepancyNoteTooLong = "Notitie te lang — maximaal 500 tekens.",
    undeliveredStopsSectionTitle = "Niet meegenomen pakketten — verwijderen uit de route",
    removedStopNoticePrefix = "\"",
    removedStopNoticeMiddle = "\" verwijderd uit de route — 1 stop minder",
    remainingStopsSuffix = "resterend",
    confirmAndStartButton = "Bevestigen en route starten",
    loadingOnBehalfOfLabel = "In opdracht van",
    loadingExpectedLabel = "Verwachte lading",
    loadingQuestionTitle = "Heeft u alle pakketten geladen?",
    loadingAllLoadedPrefix = "Ja, alle",
    loadingAllLoadedSuffix = "pakketten zijn aan boord",
    loadingIncompleteOption = "Onvolledige lading",
    loadingIncompleteHint = "Ik verwijder de betrokken stops of geef een reden op",
    loadingIncompleteRemoveLabel = "En/of verwijder de niet-geladen stops",
    slideToStartLabel = "Schuif om te starten",
    completeRouteButton = "Route beëindigen",
    completeRouteDialogTitle = "Route beëindigen?",
    completeRouteDialogPendingCountSuffix = "leveringen zijn nog niet verwerkt",
    completeRouteDialogPendingNote = "Ze worden als mislukt gemarkeerd met de hieronder opgegeven reden. U bent verantwoordelijk voor deze niet-verwerkte leveringen.",
    completeRouteDialogBody = "Deze actie is definitief: de route krijgt de status \"Voltooid\" en kan niet meer worden gewijzigd.",
    completeRouteDialogBodyAllTreated = "Alle leveringen zijn verwerkt. De route krijgt de status \"Voltooid\" en kan niet meer worden gewijzigd.",
    completeRouteDialogConfirm = "Beëindigen",
    completeRouteDialogReasonLabel = "Reden (optioneel)",
    completeRouteDialogReasonPlaceholder = "Leg uit waarom deze leveringen niet zijn verwerkt…",
    completeRouteDialogNoReasonWarning = "Als je geen reden opgeeft, worden de resterende stops geregistreerd als niet geleverd, ten laste van de vervoerder.",
    routeCompletedMessage = "Route beëindigd.",
    stopStatusUntreatedLabel = "Niet verwerkt",
    errorCompleteRouteStatusConflict = "Deze route kan niet worden beëindigd in de huidige staat.",
    errorCompleteRoutePendingStopsConflict = "Er zijn nog leveringen in behandeling. Bevestig om toch te beëindigen.",
    stopSearchOpenAction = "Een stop zoeken",
    stopSearchCloseAction = "Zoeken sluiten",
    stopSearchPlaceholder = "Naam, adres of telefoon",
    stopSearchClearTextAction = "Tekst wissen",
    stopSearchResultCount = "%1 van %2 stops",
    stopSearchResultCountOne = "1 van %1 stops",
    stopSearchEmptyTitle = "Geen stop gevonden",
    stopSearchEmptyHint = "Controleer de spelling of zoek op adres of telefoon.",
    stopSearchClearAction = "Zoekopdracht wissen",
    stopPositionLabel = "nr. %1",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Aantal pakketten",
    reoptimizeSuccessTitle = "Route heroptimaliseerd",
    backToRouteButton = "Terug naar route",
    routeBatchMultiDriverLink = "Verdelen over meerdere chauffeurs",
    routeBatchSelectTitle = "Rit verdelen",
    routeBatchDeliveriesReadyLabel = "leveringen klaar om te verdelen",
    routeBatchDriversSectionTitle = "Chauffeurs",
    routeBatchDriversSelectedSuffix = "chauffeurs geselecteerd",
    routeBatchOptimizeToggleTitle = "Route optimaliseren",
    routeBatchOptimizeToggleHelp = "RoutaR verdeelt en ordent de stops op basis van afstand. Uitgeschakeld: eenvoudige gelijke verdeling per aantal stops, zonder routeberekening.",
    routeBatchSubmitButtonPrefix = "Verdelen over",
    routeBatchDriversWord = "chauffeurs",
    routeBatchOptimizationUnavailable = "Optimalisatiedienst tijdelijk niet beschikbaar. De rit is niet aangemaakt — controleer uw verbinding en probeer opnieuw, of schakel \"Route optimaliseren\" uit voor een onmiddellijke eenvoudige verdeling.",
    routeBatchPreviewTitle = "Voorbeeld van de verdeling",
    routeBatchPreviewEyebrowMiddle = "leveringen verdeeld over",
    routeBatchPreviewEyebrowSuffix = "chauffeurs",
    routeBatchStopsChipSuffix = "stops",
    routeBatchDistanceLabel = "Afstand",
    routeBatchDurationLabel = "Geschatte duur",
    routeBatchDistanceNotCalculated = "Niet berekend",
    routeBatchOptimizeDisabledBanner = "Optimalisatie uitgeschakeld: gelijke verdeling per aantal stops, zonder afstand- of volgordeberekening.",
    routeBatchReoptimizeButton = "Opnieuw optimaliseren",
    routeBatchDispatchButton = "Bevestigen en versturen",
    errorRouteBatchAlreadyDispatched = "Deze groep ritten is al naar de chauffeurs verstuurd — wijzigen is niet meer mogelijk.",
    routeBatchDispatchedTitle = "Ritten verstuurd!",
    routeBatchDispatchedSubtitleSuffix = "chauffeurs tegelijk op de hoogte gebracht, elk met hun eigen geplande rit.",
    routeBatchStatRoutesLabel = "Ritten",
    routeBatchStatDeliveriesLabel = "Leveringen",
    routeBatchStatusLabel = "Status",
    routeBatchStatusDispatchedValue = "Verstuurd",
    routeBatchSentAtLabel = "Verstuurd op",
    routeBatchPerDriverTitle = "Detail per chauffeur",
    routeBatchDriverScheduledStatus = "Gepland",
    routeBatchBackToHomeButton = "Terug naar start",
    errorTooManyDrivers = "U kunt niet meer dan 50 chauffeurs tegelijk selecteren.",
    errorTooManyDeliveries = "Een groep mag niet meer dan 500 leveringen bevatten.",
    createRouteFabLabel = "Nieuwe rit",
    createOwnRouteButtonLabel = "Rit maken / optimaliseren",
    createOwnRouteTitle = "Mijn rit maken",
    createOwnRouteDeliveriesCountSuffix = "leveringen klaar",
    stopStatusEnRouteLabel = "Onderweg",
    yesterdayDateLabel = "Gisteren",
    periodPastLabel = "Verleden",
    periodTomorrowLabel = "Morgen",
    viewRouteButton = "Route bekijken",
    viewButton = "Bekijken",
    noRouteTomorrowTitle = "Niets gepland voor morgen",
    noRouteTomorrowSubtitle = "Plan een route van tevoren om hem morgenvroeg klaar te hebben.",
    planRouteButtonLabel = "Route plannen",
    myRoutesTodayTitle = "Uw routes van vandaag",
    myRoutesTitle = "Uw routes",
    weekdayShortNames = listOf("Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"),
    weekdayFullNames = listOf("Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"),
    monthNames = listOf("januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"),
    statRoutesTodayLabel = "Routes vandaag",
    statStopsTodayLabel = "Stops vandaag",
    statOnTimeLabel = "Op tijd vandaag",
    statAvgProgressLabel = "Gemiddelde voortgang",
    inProgressSectionTitle = "Bezig",
    upcomingSectionTitle = "Binnenkort",
    doneSectionTitle = "Voltooid",
    seeAllLabel = "Alles bekijken",
    continueRouteButton = "Route voortzetten",
    detailsLinkLabel = "Details",
    deliveryProofTitle = "Levering bevestigen",
    deliveryProofStatusSectionLabel = "Status van de levering",
    deliveryProofPhotoSectionLabel = "Bewijsfoto",
    deliveryProofPhotoHint = "Verplicht om te bevestigen",
    deliveryProofTakePhotoCta = "Foto maken",
    deliveryProofRetakePhotoCta = "Foto opnieuw maken",
    deliveryProofRetakeChipLabel = "Opnieuw",
    deliveryProofCommentSectionLabel = "Opmerking",
    failureReasonRouteClosedByDriver = "Route afgesloten door de chauffeur: stop niet geleverd, ten laste van de vervoerder.",
    deliveryProofCommentRequiredSuffix = "verplicht bij mislukking",
    deliveryProofCommentPlaceholderOptional = "Optioneel — details over de levering…",
    deliveryProofCommentPlaceholderRequired = "Leg de reden van de mislukking uit…",
    deliveryProofCommentRequiredError = "Een opmerking is verplicht bij een mislukte levering",
    deliveryProofSubmitButton = "Levering bevestigen",
    deliveryProofErrorInvalidPhoto = "Foto onleesbaar of niet-ondersteund formaat. Maak de foto opnieuw en probeer het nogmaals.",
    deliveryProofAlreadyProcessedBanner = "Deze stop is al verwerkt en kan niet meer worden gewijzigd.",
    proofPhotoViewerDownloadLabel = "Downloaden",
    proofPhotoViewerCloseLabel = "Sluiten",
    proofPhotoDownloadedMessage = "Foto opgeslagen in de galerij.",
    proofPhotoDownloadErrorMessage = "Foto kon niet worden opgeslagen.",
    deliveryConfirmTitle = "Levering bevestigd",
    deliveryConfirmSuccessTitle = "Levering bevestigd",
    deliveryConfirmSuccessSubtitle = "Het bewijs is opgeslagen voor deze stop.",
    deliveryConfirmFailedTitle = "Mislukking geregistreerd",
    deliveryConfirmFailedSubtitle = "De opmerking en de foto zijn naar de beheerder verzonden.",
    deliveryConfirmRouteCompletedTitle = "Route voltooid!",
    deliveryConfirmRouteCompletedSubtitle = "Alle stops zijn verwerkt.",
    deliveryConfirmValidatedAtLabel = "Bevestigd op",
    deliveryConfirmNextStopEyebrowPrefix = "Volgende stop",
    deliveryConfirmGoToNextStopButton = "Naar de volgende stop",
    deliveryConfirmAllDoneMessage = "Dit was de laatste stop van de route — vergeet niet deze af te sluiten.",
    offlineBannerTitle = "Offline",
    offlineBannerRouteSubtitle = "uw validaties worden verzonden zodra het netwerk terug is",
    offlineBannerValidateSubtitle = "wordt lokaal opgeslagen",
    offlineSyncingBannerTitle = "Synchronisatie bezig",
    offlineSyncingSubtitleSuffix = "leveringen verzonden",
    offlineRetryBannerTitle = "Synchronisatie mislukt",
    offlineRetryBannerSubtitle = "nieuwe poging bij de volgende netwerkverbinding",
    offlineSyncSuccessToastSuffix = "leveringen succesvol gesynchroniseerd",
    offlineQueuedBadgePendingLabel = "Wacht op verzending",
    offlineQueuedBadgeSyncingLabel = "Wordt verzonden",
    offlineQueuedBadgeFailedLabel = "Mislukt — nieuwe poging gepland",
    offlineQueuedBadgeConflictLabel = "Elders al verwerkt",
    offlineDismissConflictAction = "Verwijderen",
    offlineValidatedLocallyAtPrefix = "lokaal bevestigd om",
    offlineAddStopRequiresConnectionSuffix = "(vereist een verbinding)",
    deliveryProofOfflineSubmitButton = "Opslaan (later synchroniseren)",
    deliveryProofSavedLocallyTitle = "Lokaal opgeslagen",
    deliveryProofSavedLocallySubtitle = "Deze levering wordt automatisch verzonden zodra de verbinding is hersteld.",
    routeScheduledBannerTitle = "Rit nog niet gestart",
    routeScheduledBannerSubtitle = "Start de rit om een levering te kunnen valideren.",
    geocodeIssueTag = "Adres niet gelokaliseerd",
    regeocodeAction = "Geolocatie opnieuw proberen",
    regeocodeSuccessMessage = "Adressen bijgewerkt",
    dashboardTitle = "Dashboard",
    viewAllAction = "Alles bekijken",
    deleteRouteDialogTitle = "Route verwijderen?",
    deleteRouteDialogMessage = "Deze route wordt definitief verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
    errorRouteDeleteConflict = "Verwijderen niet mogelijk: de route is momenteel bezig.",
    errorDriverHasActiveRoute = "Er is al een andere route bezig. Beëindig deze eerst voordat u deze route start.",
    routeBatchNoStopsTag = "Geen stops",
    routeBatchNoStopsDialogTitle = "Chauffeur zonder stops",
    routeBatchNoStopsDialogMessage = "Minstens één chauffeur heeft geen stop toegewezen gekregen. Hij ontvangt toch een lege rit tenzij hij uit dit lot wordt verwijderd. Toch verzenden?",
    routeBatchAddressesToReviewTag = "adres(sen) te controleren",
    otherDeliveriesInImportLabel = "Andere leveringen van deze import",
    proofPhotoUnavailableLabel = "Foto niet beschikbaar",
    deliveryProofPhotoOptionalSectionLabel = "Foto (optioneel)",
    proofWithoutPhotoLabel = "Zonder foto",
    removeStopDialogTitle = "Deze stop verwijderen?",
    removeStopDialogMessage = "\"{name}\" ({count} pakketten) wordt uit de rit verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
    deliveryRemovedMessage = "Levering verwijderd",
    undoAction = "Ongedaan maken",
    callLaunchFailed = "Kan het gesprek niet starten op dit toestel",
    keepDraftsDialogTitleOne = "De levering behouden?",
    keepDraftsDialogTitleMany = "De {count} leveringen behouden?",
    keepDraftsDialogMessage = "U hebt ze ingevoerd, maar ze staan nog niet in de lijst.",
    keepDraftsAction = "Behouden",
    deliveriesAddedToRouteOne = "1 levering toegevoegd aan de rit",
    deliveriesAddedToRouteMany = "{count} leveringen toegevoegd aan de rit",
    driverJoinedTeamMessage = "{name} is lid geworden van het team",
    ownRouteCreatedNotOptimizedMessage = "Rit aangemaakt in de ingevoerde volgorde: de optimalisatie kon niet worden uitgevoerd",
    draftExitTitle = "Aanmaken verlaten?",
    draftExitMessageOne = "U hebt 1 levering toegevoegd ({packages} pakketten).",
    draftExitMessageMany = "U hebt {count} leveringen toegevoegd ({packages} pakketten).",
    draftKeepAction = "Bewaren voor later",
    draftDeleteDeliveriesAction = "Leveringen verwijderen",
    draftContinueAction = "Verder met aanmaken",
    draftSavedMessage = "Concept opgeslagen",
    draftCardTitle = "Rit in aanmaak",
    draftForDate = "voor {date}",
    draftResumeAction = "Hervatten",
    draftDeleteDialogTitle = "Concept verwijderen?",
    draftDeleteDialogMessageOne = "De reeds ingevoerde levering ({packages} pakketten) wordt verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
    draftDeleteDialogMessageMany = "De {count} reeds ingevoerde leveringen ({packages} pakketten) worden verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
    draftResumeImportTitle = "De lopende rit hervatten",
    draftImportAddsHint = "Geïmporteerde leveringen worden aan dit concept toegevoegd:",
    stopDeliveredAtPrefix = "Geleverd om",
    stopFailedAtPrefix = "Mislukt om",
    stopOnTimeLabel = "Op tijd",
    stopLateByPrefix = "Te laat met",
    stopTimeLabel = "Tijd",
    stopAfterStartSuffix = "na het vertrek",
    stopAfterPreviousSuffix = "na de vorige stop",
    stopDriverCommentLabel = "Opmerking van de chauffeur",
    stopPackagesLabel = "Pakketten",
    durationHoursUnit = "u",
    durationMinutesUnit = "min",
    ),
)
